export default {
    props: {
        animationCollapse: {
            type: Boolean,
            default: undefined,
            kComposite: 'animation.collapse'
        }, 
        animationCollapseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.collapse.duration'
        }, 
        animationCollapseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.collapse.effects'
        }, 
        animationExpand: {
            type: Boolean,
            default: undefined,
            kComposite: 'animation.expand'
        }, 
        animationExpandDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.expand.duration'
        }, 
        animationExpandEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.expand.effects'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-vue-wrapper/src/KendoTreeView/Animation.js